import { Component, HostListener, AfterViewInit, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { getCookie } from '../../utils/getCookies';

@Component({
  selector: 'app-company-login',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule, CommonModule, RouterLink, TranslateModule],
  templateUrl: './company-login.component.html',
  styleUrl: './company-login.component.scss'
})
export class CompanyLoginComponent implements AfterViewInit {

  loginForm: FormGroup;
    isLoading = false;
    errorMessage = '';  
    redirect_to_buy = false;          

    constructor(private fb: FormBuilder, private http: HttpClient, private router: Router, private route: ActivatedRoute, private elementRef: ElementRef) {
        this.loginForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required]]
        });

        // we need to see if the param redirect_to_buy is true
        this.route.queryParams.subscribe((params: any) => {
            if (params['redirect_to_buy'] && (params['redirect_to_buy'] === '1' || params['redirect_to_buy'] === 1)) {
                this.redirect_to_buy = true;
            }
        });


        // then we need to see if we have an actual access token (we need to check if is valid or not)
        const accessToken = getCookie('access_token');
        if (accessToken && accessToken !== '') {
            this.http.get(`${environment.url}/api/v1/company/check_access_token`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            }).subscribe({
                next: (response: any) => {
                    if (response) {
                        if (this.redirect_to_buy) {
                            this.router.navigate(['/dashboard/company/compass/buy']);
                        } else {
                            this.router.navigate(['/dashboard/company/']);
                        }
                    }
                },
                error: (error: any) => {
                    console.error('Error:', error);
                }
            })
        }
    } 

    ngAfterViewInit() {
        // Sync form values with any browser-restored input values
        setTimeout(() => {
            this.syncFormWithInputValues();
        }, 0);
    }

    private syncFormWithInputValues() {
        const emailInput = this.elementRef.nativeElement.querySelector('#email') as HTMLInputElement;
        const passwordInput = this.elementRef.nativeElement.querySelector('#password') as HTMLInputElement;
        
        if (emailInput && emailInput.value && emailInput.value !== this.loginForm.get('email')?.value) {
            this.loginForm.patchValue({ email: emailInput.value });
        }
        
        if (passwordInput && passwordInput.value && passwordInput.value !== this.loginForm.get('password')?.value) {
            this.loginForm.patchValue({ password: passwordInput.value });
        }
    }

    login() {
        if (this.loginForm.valid) {
            this.isLoading = true;
            
            this.http.post(`${environment.url}/api/company/login`, this.loginForm.value).subscribe({
                next: (response: any) => {
                    console.log(response);
                    this.isLoading = false;
                    document.cookie = `access_token=${response.access_token}; path=/;`;
                    document.cookie = `company_name=${response.name}; path=/;`;
                    // Save can_see_deep_cv flag as cookie
                    if (response.can_see_deep_cv !== undefined) {
                        document.cookie = `can_see_deep_cv=${response.can_see_deep_cv}; path=/;`;
                    }
                    if (response.is_demo_deep_cv !== undefined) {
                        document.cookie = `is_demo_deep_cv=${response.is_demo_deep_cv}; path=/;`;
                        this.router.navigate(['/dashboard/company/cv-deep-analyzer']);
                        return;
                    }
                    if (this.redirect_to_buy) {
                        this.router.navigate(['/dashboard/company/compass/buy']);
                    } else {
                        this.router.navigate(['/dashboard/company/']);
                    }
                },
                error: (error: any) => {
                    console.error('Error:', error);
                    this.isLoading = false;
                    if (error.status === 401) {
                        this.errorMessage = "Credenciales inválidas.";
                    } else if (error.status === 400) {
                        this.errorMessage = "Información incompleta.";
                    } else {
                        this.errorMessage = 'Ocurrió un error desconocido.';
                    }
                }
            });
        } else {
            this.markAllAsTouched();
            this.errorMessage = this.loginForm.invalid ? 'Hay algun campo incompleto o no válido.' : 'An unknown error occurred.';
            console.error('Form is invalid');
        }
    }

    private markAllAsTouched() {
        Object.values(this.loginForm.controls).forEach(control => {
            control.markAsTouched();
        });
    }

@HostListener('document:click', ['$event'])
handleClick(event: MouseEvent) {
    if (!(event.target as HTMLElement).closest('form')) {
        this.loginForm.markAsPristine();
        this.loginForm.markAsUntouched();
    }
}

@HostListener('focusin', ['$event'])
onFocusIn(event: FocusEvent) {
    // Sync form values when user focuses on inputs (helps with browser autofill)
    setTimeout(() => {
        this.syncFormWithInputValues();
    }, 100);
}


}
